var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.linksToShow, function(link, index) {
      return _c(
        "div",
        { key: index },
        [
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "dark",
                content: `${link.event_type}: ${_vm.format(
                  new Date(link.last_event_timestamp),
                  "d/MM/yyyy - HH:mm"
                )}`,
                placement: "top"
              }
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": _vm._f("eventsTypeIconFilter")(link.event_type)
                }
              })
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }